export const stationsFromNaritaOptions = [
  { id: 0, value: 'narita', text: 'Narita' },
  { id: 1, value: 'sakura', text: 'Sakura' },
  { id: 2, value: 'yotsukaido', text: 'Yotsukaido' },
  { id: 3, value: 'chiba', text: 'Chiba' },
  { id: 4, value: 'tokyo', text: 'Tokyo' },
  { id: 5, value: 'shinagawa', text: 'Shinagawa' },
  { id: 6, value: 'shibuya', text: 'Shibuya' },
  { id: 7, value: 'shinjuku', text: 'Shinjuku' },
  { id: 8, value: 'ikebukuro', text: 'Ikebukuro' },
  { id: 9, value: 'omiya', text: 'Omiya' },
  { id: 10, value: 'musashi_kosugi', text: 'Musashi-Kosugi' },
  { id: 11, value: 'yokohama', text: 'Yokohama' },
  { id: 12, value: 'totsuka', text: 'Totsuka' },
  { id: 13, value: 'ofuna', text: 'Ofuna' },
  { id: 14, value: 'kichijoji', text: 'Kichijoji' },
  { id: 15, value: 'mitaka', text: 'Mitaka' },
  { id: 16, value: 'kokubunji', text: 'Kokubunji' },
  { id: 17, value: 'tachikawa', text: 'Tachikawa' },
  { id: 18, value: 'hachioji', text: 'Hachioji' },
  { id: 19, value: 'takao', text: 'Takao' },
];

export const pricingTableOptions = [
  { id: 0, value: 'tokyo', text: 'Tokyo' },
  { id: 1, value: 'shibuya', text: 'Shibuya' },
  { id: 2, value: 'shinjuku', text: 'Shinjuku' },
  { id: 3, value: 'ikebukuro', text: 'Ikebukuro' },
  { id: 4, value: 'omiya', text: 'Omiya' },
  { id: 5, value: 'yokohama', text: 'Yokohama' },
  { id: 6, value: 'ofuna', text: 'Ofuna' },
];

export const stationsToNaritaOptions = [
  {
    id: 0,
    value: 'narita_airport_terminal_1',
    text: 'Narita Airport Terminal 1',
  },
  {
    id: 1,
    value: 'narita_airport_terminal_2_3',
    text: 'Narita Airport Terminal 2・3',
  },
];

export const departureTimeOptions = [
  { id: 0, value: '05:00', text: '5:00 AM' },
  { id: 1, value: '06:00', text: '6:00 AM' },
  { id: 2, value: '07:00', text: '7:00 AM' },
  { id: 3, value: '08:00', text: '8:00 AM' },
  { id: 4, value: '09:00', text: '9:00 AM' },
  { id: 5, value: '10:00', text: '10:00 AM' },
  { id: 6, value: '11:00', text: '11:00 AM' },
  { id: 7, value: '12:00', text: '12:00 PM' },
  { id: 8, value: '13:00', text: '1:00 PM' },
  { id: 9, value: '14:00', text: '2:00 PM' },
  { id: 10, value: '15:00', text: '3:00 PM' },
  { id: 11, value: '16:00', text: '4:00 PM' },
  { id: 12, value: '17:00', text: '5:00 PM' },
  { id: 13, value: '18:00', text: '6:00 PM' },
  { id: 14, value: '19:00', text: '7:00 PM' },
  { id: 15, value: '20:00', text: '8:00 PM' },
  { id: 16, value: '21:00', text: '9:00 PM' },
];

export const ticketTypeOptions = [
  { id: 0, value: 'one_way', text: 'One way', selected: true },
  { id: 1, value: 'round_trip', text: 'Round trip' },
];
